<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 142"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>online-shoppers</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-54.000000, -41.000000)">
        <g
          id="online-shoppers"
          transform="translate(54.000000, 41.000000)">
          <g id="Background">
            <g id="New_Symbol_46-64">
              <path
                id="Path"
                d="M162.580677,77.4193548 C162.577684,45.8024722 143.34971,17.3642077 114.009838,5.58290146 C84.6699655,-6.19840482 51.1142492,1.04478355 29.2464495,23.8795512 C7.37864982,46.7143188 1.59325505,80.5518584 14.6322581,109.354839 L155.690323,109.354839 C160.241153,99.3238195 162.590627,88.4344039 162.580677,77.4193548 Z"
                class="fill-extra-light"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="9.67741935"
                y1="109.354839"
                x2="160.645161"
                y2="109.354839"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="0.967741935"
                y1="109.354839"
                x2="5.80645161"
                y2="109.354839"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="164.516129"
                y1="109.354839"
                x2="169.354839"
                y2="109.354839"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Scene"
            transform="translate(16.483871, 3.870968)">
            <g
              id="Group"
              transform="translate(80.290323, 48.387097)">
              <path
                id="Path"
                d="M0.987096774,0.967741935 L55.1806452,0.967741935 C56.2495834,0.967741935 57.116129,1.83428758 57.116129,2.90322581 L57.116129,45.483871 C57.116129,46.5528092 56.2495834,47.4193548 55.1806452,47.4193548 L2.92258065,47.4193548 C1.85364242,47.4193548 0.987096774,46.5528092 0.987096774,45.483871 L0.987096774,0.967741935 Z"
                class="fill-light"
                fill-rule="nonzero"
                transform="translate(29.051613, 24.193548) rotate(180.000000) translate(-29.051613, -24.193548) " />
              <path
                id="Path"
                d="M0.987096774,40.6451613 L55.1806452,40.6451613 C56.2495834,40.6451613 57.116129,41.5117069 57.116129,42.5806452 L57.116129,47.4193548 L0.987096774,47.4193548 L0.987096774,40.6451613 Z"
                class="fill-white"
                fill-rule="nonzero"
                transform="translate(29.051613, 44.032258) rotate(180.000000) translate(-29.051613, -44.032258) " />
              <path
                id="Path"
                d="M57.0967742,47.4193548 L57.0967742,12.5806452 L70.4903226,12.5806452 C74.7034712,12.8985237 78.2760291,15.7997803 79.4516129,19.8580645 L81.9483871,29.2064516 C82.1582619,29.9890455 82.2624129,30.796216 82.2581952,31.6064516 L82.2581952,45.1548387 C82.2581952,46.4375646 81.2182097,47.4774194 79.9354839,47.4774194 L57.0967742,47.4193548 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M57.0967742,47.4193548 L57.0967742,12.5806452 L70.4903226,12.5806452 C74.7034712,12.8985237 78.2760291,15.7997803 79.4516129,19.8580645 L81.9483871,29.2064516 C82.1582619,29.9890455 82.2624129,30.796216 82.2581952,31.6064516 L82.2581952,45.1548387 C82.2581952,46.4375646 81.2182097,47.4774194 79.9354839,47.4774194 L57.0967742,47.4193548 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M0.987096774,0.967741935 L55.1806452,0.967741935 C56.2495834,0.967741935 57.116129,1.83428758 57.116129,2.90322581 L57.116129,45.483871 C57.116129,46.5528092 56.2495834,47.4193548 55.1806452,47.4193548 L2.92258065,47.4193548 C1.85364242,47.4193548 0.987096774,46.5528092 0.987096774,45.483871 L0.987096774,0.967741935 Z"
                class="stroke"
                stroke-width="1.93548387"
                transform="translate(29.051613, 24.193548) rotate(180.000000) translate(-29.051613, -24.193548) " />
              <path
                id="Path"
                d="M0.987096774,40.6451613 L55.1806452,40.6451613 C56.2495834,40.6451613 57.116129,41.5117069 57.116129,42.5806452 L57.116129,47.4193548 L0.987096774,47.4193548 L0.987096774,40.6451613 Z"
                class="stroke"
                stroke-width="1.93548387"
                transform="translate(29.051613, 44.032258) rotate(180.000000) translate(-29.051613, -44.032258) " />
              <path
                id="Path"
                d="M60.5806452,40.8387097 C64.5574982,40.6351606 68.040155,43.4815628 68.6322581,47.4193548 L73.2967742,47.4193548 C72.6683917,40.9163193 67.1114085,36.0106111 60.5806452,36.1935484 C59.4028361,36.1968243 58.2308958,36.3595938 57.0967742,36.6774194 L57.0967742,41.6129032 C58.1863796,41.0999593 59.376344,40.8355227 60.5806452,40.8387097 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M77.6129032,47.4193548 L79.9354839,47.4193548 C80.5514706,47.4193548 81.142228,47.1746551 81.5777964,46.7390867 C82.0133648,46.3035184 82.2580645,45.7127609 82.2580645,45.0967742 L82.2580645,38.516129 C79.6926128,38.516129 77.6129032,40.5958386 77.6129032,43.1612903 L77.6129032,47.4193548 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M60.5806452,40.8387097 C64.5574982,40.6351606 68.040155,43.4815628 68.6322581,47.4193548 L73.2967742,47.4193548 C72.6683917,40.9163193 67.1114085,36.0106111 60.5806452,36.1935484 C59.4028361,36.1968243 58.2308958,36.3595938 57.0967742,36.6774194 L57.0967742,41.6129032 C58.1863796,41.0999593 59.376344,40.8355227 60.5806452,40.8387097 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M52.4516129,48.9677419 C52.4516129,53.4572825 56.0911046,57.0967742 60.5806452,57.0967742 C65.0701857,57.0967742 68.7096774,53.4572825 68.7096774,48.9677419 C68.7096774,44.4782014 65.0701857,40.8387097 60.5806452,40.8387097 C56.0911046,40.8387097 52.4516129,44.4782014 52.4516129,48.9677419 Z"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M58.2580645,48.9677419 C58.2580645,50.2504678 59.2979193,51.2903226 60.5806452,51.2903226 C61.863371,51.2903226 62.9032258,50.2504678 62.9032258,48.9677419 C62.9032258,47.6850161 61.863371,46.6451613 60.5806452,46.6451613 C59.2979193,46.6451613 58.2580645,47.6850161 58.2580645,48.9677419 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M52.4516129,48.9677419 C52.4516129,53.4572825 56.0911046,57.0967742 60.5806452,57.0967742 C65.0701857,57.0967742 68.7096774,53.4572825 68.7096774,48.9677419 C68.7096774,44.4782014 65.0701857,40.8387097 60.5806452,40.8387097 C56.0911046,40.8387097 52.4516129,44.4782014 52.4516129,48.9677419 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M58.2580645,48.9677419 C58.2580645,50.2504678 59.2979193,51.2903226 60.5806452,51.2903226 C61.863371,51.2903226 62.9032258,50.2504678 62.9032258,48.9677419 C62.9032258,47.6850161 61.863371,46.6451613 60.5806452,46.6451613 C59.2979193,46.6451613 58.2580645,47.6850161 58.2580645,48.9677419 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M7.93548387,48.9677419 C7.93548387,53.4572825 11.5749756,57.0967742 16.0645161,57.0967742 C20.5540567,57.0967742 24.1935484,53.4572825 24.1935484,48.9677419 C24.1935484,44.4782014 20.5540567,40.8387097 16.0645161,40.8387097 C11.5749756,40.8387097 7.93548387,44.4782014 7.93548387,48.9677419 Z"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M13.7419355,48.9677419 C13.7419355,50.2504678 14.7817903,51.2903226 16.0645161,51.2903226 C17.347242,51.2903226 18.3870968,50.2504678 18.3870968,48.9677419 C18.3870968,47.6850161 17.347242,46.6451613 16.0645161,46.6451613 C14.7817903,46.6451613 13.7419355,47.6850161 13.7419355,48.9677419 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M7.93548387,48.9677419 C7.93548387,53.4572825 11.5749756,57.0967742 16.0645161,57.0967742 C20.5540567,57.0967742 24.1935484,53.4572825 24.1935484,48.9677419 C24.1935484,44.4782014 20.5540567,40.8387097 16.0645161,40.8387097 C11.5749756,40.8387097 7.93548387,44.4782014 7.93548387,48.9677419 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M13.7419355,48.9677419 C13.7419355,50.2504678 14.7817903,51.2903226 16.0645161,51.2903226 C17.347242,51.2903226 18.3870968,50.2504678 18.3870968,48.9677419 C18.3870968,47.6850161 17.347242,46.6451613 16.0645161,46.6451613 C14.7817903,46.6451613 13.7419355,47.6850161 13.7419355,48.9677419 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M72.7354839,30.1935484 C73.5899719,30.2810735 74.4339216,29.9492642 75,29.3032258 C75.5363822,28.6419788 75.71694,27.7608569 75.483871,26.9419355 L73.5483871,19.3548387 C73.2635382,18.3499631 72.3476879,17.6551801 71.3032258,17.6516129 L63.6774194,17.6516129 C62.3946935,17.6516129 61.3548387,18.6914677 61.3548387,19.9741935 L61.3548387,24.3677419 C61.3590517,25.258043 61.809783,26.086807 62.5548387,26.5741935 C65.5858062,28.6259318 69.0895656,29.8715649 72.7354839,30.1935484 L72.7354839,30.1935484 Z"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M63.6774194,17.6129032 L71.2064516,17.6129032 C72.2977151,17.576621 73.2692557,18.2992544 73.5483871,19.3548387 L75.483871,26.9419355 C75.7063385,27.7671297 75.5111787,28.6489629 74.9612903,29.3032258 C74.8335492,29.4413397 74.690721,29.5646913 74.5354839,29.6709677 L62.6903226,17.8258065 C62.9991361,17.681447 63.3365565,17.60867 63.6774194,17.6129032 L63.6774194,17.6129032 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M72.7354839,30.1935484 C73.5899719,30.2810735 74.4339216,29.9492642 75,29.3032258 C75.5363822,28.6419788 75.71694,27.7608569 75.483871,26.9419355 L73.5483871,19.3548387 C73.2635382,18.3499631 72.3476879,17.6551801 71.3032258,17.6516129 L63.6774194,17.6516129 C62.3946935,17.6516129 61.3548387,18.6914677 61.3548387,19.9741935 L61.3548387,24.3677419 C61.3590517,25.258043 61.809783,26.086807 62.5548387,26.5741935 C65.5858062,28.6259318 69.0895656,29.8715649 72.7354839,30.1935484 L72.7354839,30.1935484 Z"
                class="stroke"
                stroke-width="1.93548387"
                stroke-linejoin="round" />
            </g>
            <path
              id="Path"
              d="M39.3548387,49.4903226 C28.2913281,49.4903226 19.3225806,58.45907 19.3225806,69.5225806 L19.3225806,76.2 C19.367438,77.1010517 19.0290908,77.9790397 18.391162,78.6169685 C17.7532333,79.2548973 16.8752452,79.5932444 15.9741935,79.5483871 C13.46706,79.3295508 11.2327396,77.8786933 10.0129032,75.6774194 L7.70967742,71.6129032 C6.60467183,69.9242297 4.38773278,69.3678087 2.61626082,70.3345262 C0.844788857,71.3012438 0.113220965,73.4667071 0.935483871,75.3096774 L3.25806452,79.4903226 C5.73031385,84.2503679 10.6491327,87.2359939 16.0129032,87.2322581 C20.4645161,87.2322581 26.0387097,83.9032258 27.1419355,80.5548387 L27.1419355,82.7806452 L51.5870968,82.7806452 L51.5870968,96.7741935 C51.5870968,98.91207 53.3201881,100.645161 55.4580645,100.645161 C57.595941,100.645161 59.3290323,98.91207 59.3290323,96.7741935 L59.3290323,69.5225806 C59.3290323,58.481706 50.395667,49.5223251 39.3548387,49.4903226 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M39.3548387,49.4903226 C28.2913281,49.4903226 19.3225806,58.45907 19.3225806,69.5225806 L19.3225806,76.2 C19.367438,77.1010517 19.0290908,77.9790397 18.391162,78.6169685 C17.7532333,79.2548973 16.8752452,79.5932444 15.9741935,79.5483871 C13.46706,79.3295508 11.2327396,77.8786933 10.0129032,75.6774194 L7.70967742,71.6129032 C6.60467183,69.9242297 4.38773278,69.3678087 2.61626082,70.3345262 C0.844788857,71.3012438 0.113220965,73.4667071 0.935483871,75.3096774 L3.25806452,79.4903226 C5.73031385,84.2503679 10.6491327,87.2359939 16.0129032,87.2322581 C20.4645161,87.2322581 26.0387097,83.9032258 27.1419355,80.5548387 L27.1419355,82.7806452 L51.5870968,82.7806452 L51.5870968,96.7741935 C51.5870968,98.91207 53.3201881,100.645161 55.4580645,100.645161 C57.595941,100.645161 59.3290323,98.91207 59.3290323,96.7741935 L59.3290323,69.5225806 C59.3290323,58.481706 50.395667,49.5223251 39.3548387,49.4903226 Z"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <polygon
              id="Path"
              class="fill-white"
              fill-rule="nonzero"
              points="31.6322581 115.16129 32.3290323 126.290323 46.3806452 126.290323 47.0774194 115.16129" />
            <polygon
              id="Path"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="31.6322581 115.16129 32.3290323 126.290323 46.3806452 126.290323 47.0774194 115.16129" />
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="72.8193548"
              cy="134.070968"
              rx="47.8645161"
              ry="3.3483871" />
            <line
              id="Path"
              x1="39.3548387"
              y1="115.16129"
              x2="39.3548387"
              y2="122.941935"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M29.4451613,128.922581 L31.9032258,120.716129 L32.0387097,122.941935 C31.9856164,123.804964 32.2890682,124.651961 32.8781287,125.284926 C33.4671893,125.917892 34.2902248,126.281345 35.1548387,126.290323 C37.6129032,126.290323 39.3548387,125.419355 39.3548387,122.941935 L39.3548387,129.677419 C39.3548387,130.906698 38.3583112,131.903276 37.1290323,131.903276 L31.5548387,131.903276 C30.8432531,131.907999 30.1730447,131.569292 29.7548387,130.993548 C29.3286243,130.391561 29.2136863,129.622914 29.4451613,128.922581 Z"
              class="stroke fill-light"
              stroke-width="1.93548387"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M49.3225806,128.922581 L46.8064516,120.716129 L46.6516129,122.941935 C46.7048721,123.808297 46.3988291,124.658329 45.8055358,125.291908 C45.2122424,125.925486 44.3841183,126.286633 43.516129,126.290323 C41.0580645,126.290323 39.316129,125.419355 39.316129,122.941935 L39.316129,129.677419 C39.3262515,130.266065 39.5712016,130.826254 39.9964867,131.233365 C40.4217718,131.640475 40.9921185,131.860741 41.5806452,131.845161 L47.1354839,131.845161 C47.8689266,131.888407 48.575078,131.560499 49.0152843,130.972258 C49.4554907,130.384018 49.5709273,129.614052 49.3225806,128.922581 L49.3225806,128.922581 Z"
              class="stroke fill-light"
              stroke-width="1.93548387"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="1.59354839"
              y="59.516129"
              width="11.1290323"
              height="20.0322581"
              rx="1.93548387" />
            <path
              id="Path"
              d="M4.49677419,68.2258065 C6.63465064,68.2952874 8.31141647,70.0847042 8.24193548,72.2225806 C8.1724545,74.3604571 6.38303774,76.0372229 4.24516129,75.9677419 L2.56129032,75.9677419 C1.96323246,75.9514512 1.39742775,75.6929972 0.993548387,75.2516129 C0.584252753,74.8206507 0.373735167,74.2382188 0.412903226,73.6451613 L0.548387097,70.316129 C0.573502519,69.7256133 0.832456219,69.1693344 1.26815089,68.7699476 C1.70384556,68.3705608 2.28050051,68.1608651 2.87096774,68.1870968 L4.49677419,68.2258065 Z"
              class="stroke fill-white"
              stroke-width="1.93548387"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M54.9354839,31.683871 C54.9284946,30.3794722 53.9931323,29.265171 52.7096774,29.0322581 L52.7096774,27.2322581 C52.7096774,19.8565843 46.7305125,13.8774194 39.3548387,13.8774194 C31.979165,13.8774194 26,19.8565843 26,27.2322581 L26,29.0322581 C24.6345062,29.2510196 23.6528405,30.4629471 23.7223951,31.8441031 C23.7919497,33.2252591 24.8904047,34.3324323 26.2709677,34.4129032 C27.5610254,40.6059538 33.0191733,45.0442919 39.3451613,45.0442919 C45.6711493,45.0442919 51.1292972,40.6059538 52.4193548,34.4129032 C53.8384685,34.2925562 54.9305481,33.10807 54.9354839,31.683871 Z"
              class="stroke fill-white"
              stroke-width="1.93548387"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="32.116129"
              cy="33.3677419"
              r="1.66451613" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="46.5935484"
              cy="33.3677419"
              r="1.66451613" />
            <path
              id="Path"
              d="M42.683871,37.2580645 C40.7000934,38.726001 37.9902292,38.726001 36.0064516,37.2580645"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M34.3419355,27.2322581 C33.6591667,27.2244096 33.0392511,27.6296581 32.7725105,28.2582153 C32.50577,28.8867726 32.6450181,29.614187 33.1250416,30.0997921 C33.605065,30.5853971 34.330821,30.7330451 34.9624199,30.4735887 C35.5940187,30.2141323 36.0064065,29.5989429 36.0064516,28.916129 C36.0065126,27.9936592 35.2643444,27.2428612 34.3419355,27.2322581 L34.3419355,27.2322581 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M44.3677419,27.2322581 C43.6849732,27.2244096 43.0650575,27.6296581 42.798317,28.2582153 C42.5315765,28.8867726 42.6708246,29.614187 43.150848,30.0997921 C43.6308714,30.5853971 44.3566274,30.7330451 44.9882263,30.4735887 C45.6198252,30.2141323 46.032213,29.5989429 46.0322581,28.916129 C46.032319,27.9936592 45.2901509,27.2428612 44.3677419,27.2322581 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M36.4322581,10.8387097 C37.2369896,10.6825679 38.0520702,10.5855345 38.8709677,10.5483871 C40.012806,10.5192264 41.1545502,10.6100469 42.2774194,10.8193548 C44.3769941,9.50297726 45.3554258,6.9585631 44.6787787,4.57461418 C44.0021315,2.19066526 41.8328968,0.539667717 39.3548387,0.522580645 C36.8642584,0.525951557 34.6781285,2.18110906 33.9992586,4.57738483 C33.3203887,6.9736606 34.313531,9.52951245 36.4322581,10.8387097 Z"
              class="stroke fill-white"
              stroke-width="1.93548387"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M38.8709677,10.5483871 C30.3065894,11.054671 23.655752,18.2085845 23.7741935,26.7870968 L23.7741935,39.483871 C23.7769537,42.0217569 24.6515809,44.4816459 26.2516129,46.4516129 C26.5503408,46.7952354 27.029483,46.9200386 27.4578864,46.7658134 C27.8862897,46.6115882 28.1759384,46.2100203 28.1870968,45.7548387 L28.1870968,34.8387097 C28.1785801,32.0098179 29.4701854,29.33384 31.6903226,27.5806452 C33.7974106,26.00615 35.6850288,24.1575859 37.3032258,22.083871 C37.9207437,21.2079761 39.0677052,20.8848883 40.0516129,21.3096774 C44.9677419,23.4580645 47.4451613,27.116129 49.7290323,29.5741935 C50.0656452,29.9237773 50.5887864,30.0174742 51.0258065,29.8064516 C51.3654492,29.6262005 51.74453,29.5330929 52.1290323,29.5354839 C52.8373744,29.4703194 53.5405123,29.7057056 54.0668562,30.1842001 C54.5932002,30.6626946 54.8943353,31.3402839 54.8967742,32.0516129 L54.8967742,26.2451613 C54.9245873,22.0161784 53.2342378,17.9571161 50.2129761,14.9978851 C47.1917144,12.0386542 43.0984639,10.4328618 38.8709677,10.5483871 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M38.8709677,10.5483871 C30.3065894,11.054671 23.655752,18.2085845 23.7741935,26.7870968 L23.7741935,39.483871 C23.7769537,42.0217569 24.6515809,44.4816459 26.2516129,46.4516129 C26.5503408,46.7952354 27.029483,46.9200386 27.4578864,46.7658134 C27.8862897,46.6115882 28.1759384,46.2100203 28.1870968,45.7548387 L28.1870968,34.8387097 C28.1785801,32.0098179 29.4701854,29.33384 31.6903226,27.5806452 C33.7974106,26.00615 35.6850288,24.1575859 37.3032258,22.083871 C37.9207437,21.2079761 39.0677052,20.8848883 40.0516129,21.3096774 C44.9677419,23.4580645 47.4451613,27.116129 49.7290323,29.5741935 C50.0656452,29.9237773 50.5887864,30.0174742 51.0258065,29.8064516 C51.3654492,29.6262005 51.74453,29.5330929 52.1290323,29.5354839 C52.8373744,29.4703194 53.5405123,29.7057056 54.0668562,30.1842001 C54.5932002,30.6626946 54.8943353,31.3402839 54.8967742,32.0516129 L54.8967742,26.2451613 C54.9245873,22.0161784 53.2342378,17.9571161 50.2129761,14.9978851 C47.1917144,12.0386542 43.0984639,10.4328618 38.8709677,10.5483871 Z"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M51.5870968,75.0967742 C51.3858953,73.6241342 51.7832568,72.132286 52.6903226,70.9548387 C53.5318318,69.9362028 53.8341119,68.5759424 53.5032258,67.2967742 L59.3096774,67.2967742 C58.8607076,63.640868 57.4143598,60.1790078 55.1290323,57.2903226 L23.5032258,57.2903226 C21.2595467,60.1917775 19.8538092,63.6525694 19.4387097,67.2967742 L25.2451613,67.2967742 C24.9215474,68.5821062 25.2387415,69.9445991 26.0967742,70.9548387 C27.0118872,72.1283006 27.4101648,73.6235888 27.2,75.0967742 L27.2,82.8387097 C27.2,82.8387097 25.2645161,88.1032258 25.1096774,112.877419 C25.1077808,113.473203 25.3448166,114.044878 25.7677419,114.464516 C26.1801817,114.886335 26.7455379,115.123645 27.3354839,115.122584 L51.4709677,115.122584 C52.0609137,115.123645 52.6262699,114.886335 53.0387097,114.464516 C53.461635,114.044878 53.6986708,113.473203 53.6967742,112.877419 C53.5806452,88.1032258 51.5870968,82.8387097 51.5870968,82.8387097 L51.5870968,75.0967742 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <rect
              id="Rectangle"
              class="fill-light"
              fill-rule="nonzero"
              x="30.4516129"
              y="57.2903226"
              width="3.3483871"
              height="57.8709677" />
            <rect
              id="Rectangle"
              class="fill-light"
              fill-rule="nonzero"
              x="37.1290323"
              y="57.2903226"
              width="4.4516129"
              height="57.8709677" />
            <rect
              id="Rectangle"
              class="fill-light"
              fill-rule="nonzero"
              x="44.9096774"
              y="57.2903226"
              width="3.3483871"
              height="57.8709677" />
            <path
              id="Path"
              d="M51.5870968,75.0967742 C51.3858953,73.6241342 51.7832568,72.132286 52.6903226,70.9548387 C53.5318318,69.9362028 53.8341119,68.5759424 53.5032258,67.2967742 L59.3096774,67.2967742 C58.8607076,63.640868 57.4143598,60.1790078 55.1290323,57.2903226 L23.5032258,57.2903226 C21.2595467,60.1917775 19.8538092,63.6525694 19.4387097,67.2967742 L25.2451613,67.2967742 C24.9215474,68.5821062 25.2387415,69.9445991 26.0967742,70.9548387 C27.0118872,72.1283006 27.4101648,73.6235888 27.2,75.0967742 L27.2,82.8387097 C27.2,82.8387097 25.2645161,88.1032258 25.1096774,112.877419 C25.1077808,113.473203 25.3448166,114.044878 25.7677419,114.464516 C26.1801817,114.886335 26.7455379,115.123645 27.3354839,115.122584 L51.4709677,115.122584 C52.0609137,115.123645 52.6262699,114.886335 53.0387097,114.464516 C53.461635,114.044878 53.6986708,113.473203 53.6967742,112.877419 C53.5806452,88.1032258 51.5870968,82.8387097 51.5870968,82.8387097 L51.5870968,75.0967742 Z"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="fill-white"
              fill-rule="nonzero"
              x="60.4903226"
              y="109.587097"
              width="37.8387097"
              height="22.2580645"
              rx="1.93548387" />
            <rect
              id="Rectangle"
              class="fill-white"
              fill-rule="nonzero"
              transform="translate(77.183871, 98.477419) rotate(90.000000) translate(-77.183871, -98.477419) "
              x="66.0548387"
              y="88.4612903"
              width="22.2580645"
              height="20.0322581"
              rx="1.93548387" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="60.4903226"
              y="109.587097"
              width="37.8387097"
              height="22.2580645"
              rx="1.93548387" />
            <polyline
              id="Path"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="61.2645161 110.148387 79.4193548 122.96129 97.5548387 110.148387" />
            <line
              id="Path"
              x1="61.1870968"
              y1="131.225806"
              x2="73.8451613"
              y2="119.612903"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="97.6516129"
              y1="131.225806"
              x2="84.9741935"
              y2="119.612903"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="translate(77.183871, 98.477419) rotate(90.000000) translate(-77.183871, -98.477419) "
              x="66.0548387"
              y="88.4612903"
              width="22.2580645"
              height="20.0322581"
              rx="1.93548387" />
            <line
              id="Path"
              x1="87.2"
              y1="97.3548387"
              x2="67.1677419"
              y2="97.3548387"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="77.1935484"
              y1="87.3290323"
              x2="77.1935484"
              y2="109.587097"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M93.1225806,118.490323 L94.5741935,116.806452 C95.3696678,115.870845 95.2570737,114.46775 94.3225806,113.670968 L85.8645161,106.451613 L81.1612903,106.819355 L81.5290323,111.522581 L89.9677419,118.741935 C90.4181167,119.13003 91.0050347,119.32182 91.5976737,119.274554 C92.1903128,119.227288 92.7394126,118.944896 93.1225806,118.490323 Z"
              class="stroke fill-light"
              stroke-width="1.93548387"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M77.4064516,97.3548387 C76.7708732,100.959997 78.223972,104.615215 81.1612903,106.8"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="fill-white"
              fill-rule="nonzero"
              transform="translate(109.458065, 112.945161) rotate(90.000000) translate(-109.458065, -112.945161) "
              x="90.5387097"
              y="101.816129"
              width="37.8387097"
              height="22.2580645"
              rx="1.93548387" />
            <rect
              id="Rectangle"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round"
              transform="translate(109.458065, 112.945161) rotate(90.000000) translate(-109.458065, -112.945161) "
              x="90.5387097"
              y="101.816129"
              width="37.8387097"
              height="22.2580645"
              rx="1.93548387" />
            <line
              id="Path"
              x1="109.458065"
              y1="94.0064516"
              x2="109.458065"
              y2="131.845161"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M124.806452,117.058065 L126.606452,115.741935 C127.592829,115.010368 127.808408,113.622042 127.090323,112.625806 L120.529032,103.645161 L115.864516,102.909677 L115.129032,107.593548 L121.690323,116.574194 C122.42189,117.560571 123.810216,117.77615 124.806452,117.058065 Z"
              class="stroke fill-light"
              stroke-width="1.93548387"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M111.412903,94.0064516 C111.741935,98.0709677 112.883871,100.858065 115.767742,102.909677"
              class="stroke"
              stroke-width="1.93548387"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
